/**
 * Gets all next sibling elements.
 *
 * @param elem
 * @returns {Array}
 */
export function nextAll(elem) {
  // Setup siblings array
  var siblings = [];

  // Get the next sibling element
  elem = elem.nextElementSibling;

  // As long as a sibling exists
  while (elem) {
    // Push it to the siblings array
    siblings.push(elem);

    // Get the next sibling element
    elem = elem.nextElementSibling;
  }

  return siblings;
}

/**
 * Gets all previous sibling elements.
 *
 * @param elem
 * @returns {Array}
 */
export function prevAll(elem) {
  // Setup siblings array
  var siblings = [];

  // Get the previous sibling element
  elem = elem.previousElementSibling;

  // As long as a sibling exists
  while (elem) {
    // Push it to the siblings array
    siblings.push(elem);

    // Get the previous sibling element
    elem = elem.previousElementSibling;
  }

  return siblings;
}
